export default __webpack_public_path__ + "static/media/Midna_Appear.6d68091b.wav";